import Rule from '@/page/apply/notify/Rule';
import SmsConsumeRecord from '@/page/apply/notify/SmsConsumeRecord';
import SmsRecharge from '@/page/apply/notify/SmsRecharge'

export const apply = [{
  path: '/apply/notify/rule',
  name: 'rule',
  component: Rule,
  meta: {
    requireAuth: true,
    title: '通知规则'
  }
}, {
  path: '/apply/notify/sms/recharge',
  name: 'smsRecharge',
  component: SmsRecharge,
  meta: {
    requireAuth: true,
    title: '短信充值'
  }
},
  {
    path: '/apply/notify/sms/consume/record',
    name: 'smsConsumeRecord',
    component: SmsConsumeRecord,
    meta: {
      requireAuth: true,
      title: '短信明细'
    }
  },
];



// WEBPACK FOOTER //
// ./src/router/apply.route.js